import { useRef, useCallback } from "react";
import axios from "axios";

export function useCancelableDebouncedRequest(delay = 250) {
    const cancelTokenRef = useRef(null);
    const debounceTimerRef = useRef(null);

    const sendRequest = useCallback((apiFn, payload) => {
        return new Promise((resolve, reject) => {

            // Cancel previous API call
            if (cancelTokenRef.current) {
                cancelTokenRef.current.cancel("Previous request cancelled");
            }

            // Create new cancel token
            cancelTokenRef.current = axios.CancelToken.source();

            // Clear old debounce
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }

            // Debounced execution
            debounceTimerRef.current = setTimeout(async () => {
                try {
                    const response = await apiFn(payload, cancelTokenRef.current.token);

                    if (response?.data?.success) resolve(response);
                    else reject(new Error("API returned unsuccessful status"));
                } catch (error) {
                    if (axios.isCancel(error)) {
                        console.warn("Request cancelled:", error.message);
                        return; // do nothing
                    }
                    reject(error);
                }
            }, delay);
        });
    }, [delay]);

    return sendRequest;
}
